import { ApiSet, BaseResponse, useShowApi } from 'utils/network/api_hooks'
import { Form, useEffectSkipFirst } from 'utils/hooks'
import { CraifHttpClient } from '../utils/network/axios'

type AnalyticsResponse = BaseResponse & {
    yieldCount?: { name: string; value: number }[]
    avgCount?: {
        avgExtraction: number
        avgDna: number
        avgPcr: number
    }
    avgTat?: number
}

export type AnalyticsSearchParams = {
    startDate?: string
    endDate?: string
}

export function useFetchAnalyticsApi(searchForm: Form<AnalyticsSearchParams>): ApiSet<AnalyticsResponse> & { execute: () => void } {
    const apiPath = 'analytics/'
    const api = useShowApi<AnalyticsResponse>(new CraifHttpClient(), {
        initialResponse: {},
    })

    const execute = (): void => {
        api.execute(apiPath, searchForm.object)
    }

    useEffectSkipFirst(() => {
        api.execute(apiPath, searchForm.object)
    }, [searchForm.object])

    return { ...api, execute: execute }
}
